export default __webpack_public_path__ + "static/media/gear.0d82c213.svg";